import React from 'react';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';
import {CheckCircleOutlined} from '@ant-design/icons';
import {Button} from 'antd';

import {INDEX} from '../../../../config/routes';

import cls from './Success.module.scss'

export const SuccessFinProtectionDate = () => {

    const navigate = useNavigate();

    const {state} = useLocation();
    const {CertNumber} = state;

    return (
        <div className={cls.page}>
            <div className={'content'}>
                <div className={cls.text}>
                    <h2><CheckCircleOutlined className={'color-success'}/> Ваша заявка на возврат принята</h2>
                    <p>
                        Уважаемый Клиент,<br/>
                        Группа компаний &laquo;FTS Group&raquo; благодарит Вас за&nbsp;обращение.
                    </p>
                    <p>
                        Ваше заявление на&nbsp;возврат по&nbsp;сертификату <b>{CertNumber}</b> принято в&nbsp;обработку.<br/>
                        Оплаченные денежные средства за&nbsp;продукт «Финансовая защита» будут зачислены в&nbsp;счет погашения выданного вам займа в&nbsp;компании МикроРезерв
                        в&nbsp;течение 14-ти дней с&nbsp;момента подачи заявления, если возврат предусмотрен условиями сертификата и&nbsp;заявление подано не&nbsp;позднее 30-го календарного дня с&nbsp;момента оплаты сертификата.
                    </p>
                    <Button type={'primary'} size={'large'} onClick={() => navigate(INDEX)}>Хорошо</Button>
                </div>
            </div>

            {/*<Banner/>*/}

        </div>
    );
}


